import { UploadedFile } from "../types/Transaction";
import optionsApi from "./optionsApi";

export async function getAllGrantRelatedDocs(
  grantId: string
): Promise<UploadedFile[]> {
  return optionsApi
    .get("v1/grant/getGrantDocuments", {
      params: { grantId },
    })
    .then((res) => res.data.data);
}
